import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// 按需引入element组件
import {Button,Input,Menu,MenuItem,Submenu,RadioGroup,RadioButton,MenuItemGroup,Table,TableColumn,Popconfirm,
        Dialog,Form,FormItem,Select,Option,DatePicker,Message,Col,Pagination,Tag,Upload,Tooltip} from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(Button);
Vue.use(Input);
Vue.use(Menu);
Vue.use(MenuItem);
Vue.use(Submenu);
Vue.use(RadioGroup);
Vue.use(RadioButton);
Vue.use(MenuItemGroup);
Vue.use(Dialog);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Select);
Vue.use(Option);
Vue.use(DatePicker);
Vue.use(Col);
Vue.use(Pagination);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Popconfirm);
Vue.use(Tag);
Vue.use(Upload);
Vue.use(Tooltip);
Vue.component(Message)
//挂载到Vue全局对象上
Vue.prototype.$message = Message

// 适配文件
import './utils/rem'  
// import 'lib-flexible'
// 全局初始化css文件
import './assets/css/reset.min.scss'

// 引入animated文件
import './assets/css/animate.min.css'

// 引入wow.js
import WOW from 'wowjs'
Vue.use(WOW)
Vue.prototype.$WOW = WOW



Vue.config.productionTip = false
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')